<template>
  <v-dialog v-model="openMode" max-width="640px" content-class="pl-dialog" overlay-color="#0d2c6d"
    overlay-opacity="0.55" transition="dialog-bottom-transition" persistent>
    <v-card class="pl-dlg-card">

      <!-- ───────── HEADER ───────── -->
      <div class="pl-dlg-head">
        <div class="pl-dlg-head__main">
          <div class="pl-dlg-head__icon" aria-hidden="true">
            <v-icon color="#fff" size="22">
              {{ formTitle === 'ערוך חבילה' ? 'mdi-package-variant' : 'mdi-package-variant-plus' }}
            </v-icon>
          </div>
          <div>
            <span class="pl-dlg-eyebrow">חבילות</span>
            <h2 class="pl-dlg-title">{{ formTitle }}</h2>
          </div>
        </div>
        <button type="button" class="pl-dlg-close" @click="openMode = false" :disabled="progressShow" aria-label="סגור">
          <v-icon color="#fff" size="18">mdi-close</v-icon>
        </button>
      </div>

      <!-- ───────── BODY ───────── -->
      <v-card-text class="pl-dlg-body">
        <v-form @submit.prevent="submitHandler" ref="form">

          <!-- Section: Basic info -->
          <div class="pl-dlg-section">
            <h3 class="pl-dlg-section__title">
              <span class="pl-dlg-section__bar"></span>
              פרטי חבילה
            </h3>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense v-model="itemEdited.name" label="שם חבילה"
                  prepend-inner-icon="mdi-tag-outline" hide-details="auto" :rules="[v => !!v || 'שדה חובה']" required
                  placeholder="לדוגמה: חבילת 100GB"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense v-model="itemEdited.pack_id" type="number" hide-spin-buttons
                  label="מזהה חבילה" prepend-inner-icon="mdi-pound" hide-details="auto"
                  :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea outlined dense v-model="itemEdited.details" label="פרטי החבילה"
                  prepend-inner-icon="mdi-text-box-outline" rows="3" hide-details="auto"
                  :rules="[v => !!v || 'שדה חובה']" required
                  placeholder="תאר מה כוללת החבילה — דקות, נפחים, הטבות וכו'"></v-textarea>
              </v-col>
            </v-row>
          </div>

          <!-- Section: Carrier + Price -->
          <div class="pl-dlg-section">
            <h3 class="pl-dlg-section__title">
              <span class="pl-dlg-section__bar"></span>
              חברה ומחיר
            </h3>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-select outlined dense :items="operating_companys" :item-text="'hebrewName'" :item-value="'name'"
                  v-model="itemEdited.operating_company" label="חברה מפעילה" prepend-inner-icon="mdi-cellphone-wireless"
                  hide-details="auto" :rules="[v => !!v || 'שדה חובה']" required placeholder="בחר חברה"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense v-model="itemEdited.price" type="number" hide-spin-buttons label="מחיר"
                  prepend-inner-icon="mdi-currency-ils" suffix="ש״ח" hide-details="auto"
                  :rules="[v => !!v || 'שדה חובה']" required placeholder="0" class="pl-price-field"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <!-- Section: Visibility -->
          <div class="pl-dlg-section pl-dlg-section--toggle">
            <div class="pl-toggle-row">
              <div class="pl-toggle-row__icon" :class="{ 'pl-toggle-row__icon--on': itemEdited.show_to_user }">
                <v-icon size="18">
                  {{ itemEdited.show_to_user ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                </v-icon>
              </div>
              <div class="pl-toggle-row__body">
                <span class="pl-toggle-row__title">תצוגה למשתמשים</span>
                <span class="pl-toggle-row__hint">
                  {{ itemEdited.show_to_user
                    ? 'החבילה תוצג ללקוחות בעת הקמת מנוי חדש'
                    : 'החבילה מוסתרת ולא תופיע בעת הקמת מנוי' }}
                </span>
              </div>
              <v-switch v-model="itemEdited.show_to_user" color="#3F51B5" hide-details inset
                class="pl-toggle-row__switch"></v-switch>
            </div>
          </div>

        </v-form>
      </v-card-text>

      <!-- ───────── FOOTER ───────── -->
      <div class="pl-dlg-foot">
        <v-progress-linear v-if="progressShow" indeterminate color="#3F51B5" height="2" />
        <div class="pl-dlg-foot__actions">
          <button type="button" class="pl-dlg-btn pl-dlg-btn--ghost" @click="openMode = false"
            :disabled="progressShow">ביטול</button>
          <button type="button" class="pl-dlg-btn pl-dlg-btn--primary"
            @click="formTitle === 'ערוך חבילה' ? saveEditedPlan() : saveNewPlan()" :disabled="progressShow">
            <v-icon v-if="!progressShow" size="16" color="#fff">
              {{ formTitle === 'ערוך חבילה' ? 'mdi-check' : 'mdi-plus' }}
            </v-icon>
            <span>{{ progressShow ? 'שומר...' : (formTitle === 'ערוך חבילה' ? 'שמור שינויים' : 'צור חבילה') }}</span>
          </button>
        </div>
      </div>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    planToEdit: Object,
    formTitle: String,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    itemEdited: {
      name: "",
      price: "",
      operating_company: "",
      details: "",
      show_to_user: false,
      pack_id: "",
    },
    operating_companys: [
      { hebrewName: "פרטנר", name: "partner" },
      { hebrewName: "הוט מובייל", name: "hotMobile" },
      { name: "clickCallMobile", hebrewName: "קליקול מובייל" }
    ],
  }),
  methods: {
    async saveNewPlan() {
      if (this.$refs.form.validate()) {
        const ivrJSON = JSON.stringify({ plan: this.itemEdited });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/plans/create_plan";
          const res = await fetch(api, ApiServices.requestOptions("POST", ivrJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planCreated", this.itemEdited, "החבילה נוצרה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved new plan: " + error, "red");
        }
      }
    },
    async saveEditedPlan() {
      if (this.$refs.form.validate()) {
        const ivrJSON = JSON.stringify({ plan: this.itemEdited });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/plans/edit_plan";
          const res = await fetch(api, ApiServices.requestOptions("PUT", ivrJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planEdited", this.itemEdited, "החבילה עודכנה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved edited plan: " + error, "red");
        }
      }
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  mounted() {
    if (this.formTitle === "ערוך חבילה") {
      this.itemEdited = JSON.parse(JSON.stringify(this.planToEdit));
    }
  },
}
</script>

<style scoped>
.pl-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

.pl-dlg-card {
  --c-navy: #0d2c6d;
  --c-indigo: #3F51B5;
  --c-indigo-deep: #303f9f;
  --c-gold: #fdb721;
  --c-gold-deep: #e09e0a;
  --c-border-soft: #eef2f7;
  --c-text: #0f172a;
  --c-text-soft: #475569;
  --c-text-mute: #94a3b8;
  font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
  direction: rtl;
  background: #ffffff !important;
  border-radius: 20px !important;
  overflow: hidden;
}

/* ─── HEADER (indigo flourish — Plans theme) ─── */
.pl-dlg-head {
  background:
    radial-gradient(700px 200px at 90% -40%, rgba(63, 81, 181, 0.30), transparent 60%),
    linear-gradient(135deg, #0d2c6d 0%, #1c2a85 55%, #283b9d 100%);
  color: #fff;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.pl-dlg-head__main {
  display: flex;
  align-items: center;
  gap: 14px;
}

.pl-dlg-head__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(63, 81, 181, 0.32);
  border: 1px solid rgba(255, 255, 255, 0.22);
  display: grid;
  place-items: center;
}

.pl-dlg-eyebrow {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 1px;
}

.pl-dlg-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #fff;
}

.pl-dlg-close {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.2s, transform 0.2s;
}

.pl-dlg-close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.18);
  transform: rotate(90deg);
}

.pl-dlg-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── BODY ─── */
.pl-dlg-body {
  padding: 22px 26px 8px !important;
  background: #fbfcfe;
  max-height: 68vh;
  overflow-y: auto;
}

.pl-dlg-section {
  margin-bottom: 16px;
  padding: 16px 18px 6px;
  background: #ffffff;
  border: 1px solid var(--c-border-soft);
  border-radius: 14px;
}

.pl-dlg-section--toggle {
  padding: 14px 16px;
}

.pl-dlg-section__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--c-navy);
  margin: 0 0 14px;
}

.pl-dlg-section__bar {
  width: 3px;
  height: 16px;
  background: linear-gradient(180deg, var(--c-navy), var(--c-indigo));
  border-radius: 2px;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-select--outlined fieldset,
::v-deep .v-textarea--outlined fieldset {
  border-color: #e3e8ef !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}

::v-deep .v-text-field--outlined:hover fieldset,
::v-deep .v-select--outlined:hover fieldset,
::v-deep .v-textarea--outlined:hover fieldset {
  border-color: #c7d2e0 !important;
}

::v-deep .v-input--is-focused fieldset {
  border-color: var(--c-indigo) !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 4px rgba(63, 81, 181, 0.08);
}

::v-deep .v-input__prepend-inner {
  margin-top: 9px !important;
}

::v-deep .v-input__prepend-inner .v-icon {
  color: var(--c-text-mute) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon {
  color: var(--c-indigo) !important;
}

::v-deep .pl-price-field input {
  font-weight: 800;
  color: var(--c-gold-deep);
  font-size: 1rem;
}

/* ─── TOGGLE ROW ─── */
.pl-toggle-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.pl-toggle-row__icon {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  background: rgba(148, 163, 184, 0.12);
  color: var(--c-text-mute);
  transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
  flex-shrink: 0;
}

.pl-toggle-row__icon--on {
  background: rgba(63, 81, 181, 0.12);
  color: var(--c-indigo);
}

.pl-toggle-row__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.pl-toggle-row__title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--c-text);
  margin-bottom: 1px;
}

.pl-toggle-row__hint {
  font-size: 0.78rem;
  color: var(--c-text-mute);
  font-weight: 500;
}

.pl-toggle-row__switch {
  margin: 0 !important;
  padding: 0 !important;
}

::v-deep .pl-toggle-row__switch .v-input__slot {
  margin-bottom: 0 !important;
}

/* ─── FOOTER ─── */
.pl-dlg-foot {
  background: #ffffff;
  border-top: 1px solid var(--c-border-soft);
}

.pl-dlg-foot__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
}

.pl-dlg-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 22px;
  border-radius: 10px;
  border: none;
  font-family: inherit;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.pl-dlg-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pl-dlg-btn--ghost {
  background: transparent;
  color: var(--c-text-soft);
  border: 1px solid #e3e8ef;
}

.pl-dlg-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
  color: var(--c-text);
}

.pl-dlg-btn--primary {
  background: linear-gradient(135deg, var(--c-indigo) 0%, var(--c-indigo-deep) 100%);
  color: #fff;
  box-shadow: 0 6px 14px -4px rgba(63, 81, 181, 0.50);
}

.pl-dlg-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.08);
}

@media (max-width: 600px) {
  .pl-dlg-head {
    padding: 14px 18px;
  }

  .pl-dlg-title {
    font-size: 1rem;
  }

  .pl-dlg-body {
    padding: 18px 18px 4px !important;
  }

  .pl-dlg-section {
    padding: 14px 14px 4px;
  }

  .pl-dlg-foot__actions {
    padding: 12px 16px;
  }

  .pl-dlg-btn {
    padding: 9px 16px;
    font-size: 0.85rem;
  }
}
</style>